import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { PAGES } from '../../constants/pages';
import {
  APPLICATION_TYPE_INDIVIDUAL,
  APPLICATION_TYPE_JOINT_TENANTS,
  APPLICATION_TYPE_CORPORATE,
  ACCOUNT_TYPE_CORPORATE_TRUST,
} from '../../constants/accountTypes';
import useChooseApplication from '../../hooks/useChooseApplication';
import BaseLayout from '../../components/BaseLayout';
import { Heading } from '../../components/Heading';
import SelectList from '../../components/SelectList/SelectList';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import SaveAndCloseModal from '../../components/Modals/SaveAndCloseModal/SaveAndCloseModal';
import { gtmStepHelper } from '../../util/helpers/gtmHelper';
import { ACCOUNT_STEP_COMPLETE, ACCOUNT_STEP_VIEW } from '../../util/gtmEvents';
import useGtmStepHook from '../../util/hooks/useGtmStepHook';
import { retrieveFromSessionStorage } from '../../util/helpers/sessionStorageHelper';
import { ACCOUNT_TYPE_GTM } from '../../constants/sessionStorage';

const ChooseApplicationStandard = () => {
  const { t } = useTranslation();
  const { onSelectType } = useChooseApplication();
  const { BrokerName } = useSelector(selectSettings);
  const [eventType, setEventType] = useState('NoForm');
  const [saveAndCloseModalOpen, setSaveAndCloseModalOpen] = useState(false);
  const { gtmStepEvent } = useGtmStepHook();
  const accountGtmType = retrieveFromSessionStorage(ACCOUNT_TYPE_GTM);

  const gtmEvent = () => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_COMPLETE,
      stepLabel: 'Choose application Standard',
      accountType: accountGtmType,
      customParams: {
        timestamp: new Date().toISOString(),
      },
    });
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_VIEW,
      stepLabel: 'Secure Account Introduction',
      accountType: accountGtmType,
      customParams: {
        timestamp: new Date().toISOString(),
      },
    });
  };

  const options = [
    {
      title: t('selectPath.options.standard.owner.me'),
      onClick: () => {
        onSelectType({ ApplicationType: APPLICATION_TYPE_INDIVIDUAL });
        gtmEvent();
      },
    },
    {
      title: t('selectPath.options.standard.owner.joint'),
      onClick: () => {
        onSelectType({ ApplicationType: APPLICATION_TYPE_JOINT_TENANTS });
        gtmEvent();
      },
    },
    {
      title: t('selectPath.options.standard.owner.trust'),
      onClick: () => {
        onSelectType({
          ApplicationType: APPLICATION_TYPE_CORPORATE,
          CorporateAccountType: ACCOUNT_TYPE_CORPORATE_TRUST,
        });
        gtmEvent();
      },
    },
    {
      title: t('selectPath.options.standard.owner.business'),
      onClick: () => {
        onSelectType({
          ApplicationType: APPLICATION_TYPE_CORPORATE,
        });
        gtmEvent();
      },
      showDivider: false,
    },
  ];

  return (
    <BaseLayout
      canShowEmail={false}
      previousPath={PAGES.CHOOSE_APPLICATION.MAIN}
      setEventType={setEventType}
      eventType={eventType}
      setSaveAndCloseModalOpen={setSaveAndCloseModalOpen}
    >
      <Helmet>
        <title>
          {t('selectPath.options.standard.titleTag', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={28}>{t('selectPath.options.standard.owner.title')}</Heading>
      <SelectList options={options} />
      {saveAndCloseModalOpen && (
        <SaveAndCloseModal
          isOpen={saveAndCloseModalOpen}
          onClose={() => setSaveAndCloseModalOpen(false)}
        />
      )}
    </BaseLayout>
  );
};

export default ChooseApplicationStandard;
